module.exports = __webpack_public_path__ + "files/9d371cdbbc31547290d2fb1556f3b776.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/exo2-bold-webfont.svg
 ** module id = 908
 ** module chunks = 0
 **/